// extracted by mini-css-extract-plugin
export default {"duties":"Duties_duties__-vhZc","duties__inner":"Duties_duties__inner__Ehxum","duties__title":"Duties_duties__title__2hNMw","duties__link":"Duties_duties__link__GlKJv"};